import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const TreatmentsCtx = createContext({ items: [], loading: true, refresh: () => {} });

export const TreatmentsProvider = ({ children }) => {
  const [state, setState] = useState({ items: [], loading: true });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/treatments");
      setState({ items: data || [], loading: false });
    } catch {
      setState(s => ({ ...s, loading: false }));
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <TreatmentsCtx.Provider value={{ ...state, refresh }}>{children}</TreatmentsCtx.Provider>;
};

export const useTreatments = () => useContext(TreatmentsCtx);
